import { ApiError } from '../api/ApiError';

export const getApiErrorMessage = (error: unknown, fallback: string): string =>
  error instanceof Error && error.message ? error.message : fallback;

export const isForbiddenError = (error: unknown): error is ApiError =>
  error instanceof ApiError && error.statusCode === 403;

export const isNotFoundError = (error: unknown): error is ApiError =>
  error instanceof ApiError && error.statusCode === 404;
